import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class BillService {

  constructor(private http: HttpClient) { }

  saveBill(id: any, data: any) {
    const { company, ...payload } = data
    const companyId = company?.id || company?._id || company;

    if (id) {
      return this.http.put(urls.API_URL + urls.BILLS + `/${companyId}/${id}`, payload)
        .pipe(catchError(errorHandl));
    }

    return this.http.post(urls.API_URL + urls.BILLS + '/' + companyId, payload)
      .pipe(catchError(errorHandl));
  }

  getBills(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.BILLS, { params })
      .pipe(catchError(errorHandl));
  }

  getBillById(id: any) {
    return this.http.get(urls.API_URL + urls.BILLS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  syncBill(companyId: any, billId: any, queryParams: any = {}) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.BILLS + `/${companyId}/${urls.SYNC}/${billId}`, { params })
      .pipe(catchError(errorHandl));
  }

  deleteBill(companyId: any, billId: any) {
    return this.http.delete(urls.API_URL + urls.BILLS + `/${companyId}/${billId}`)
      .pipe(catchError(errorHandl));
  }

  sendEmail(companyId: any, billId: any) {
    return this.http.get(urls.API_URL + urls.BILLS + `/send/` + `${companyId}/${billId}`)
      .pipe(catchError(errorHandl));
  }
}
